import { useIdleDetection } from './useIdleDetection'
import { usePageVisibility } from './usePageVisibility'

/**
 * Returns the given polling interval when the tab is visible and the user is active,
 * or 0 (disabled) when the tab is hidden or the user has been idle for 10 minutes.
 * Falls back to the original interval if anything goes wrong.
 */
export function usePollingInterval(interval: number): number {
  const isVisible = usePageVisibility()
  const isIdle = useIdleDetection()

  try {
    return isVisible && !isIdle ? interval : 0
  } catch {
    return interval
  }
}
